import useLogger from "@src/presentation/hooks/logger/useLogger";
import * as Sentry from "@sentry/react";
import ErrorFallback from "./ErrorFallback";

interface ErrorBoundaryProps {
  children: React.ReactNode;
  showDialog?: boolean;
  onError?: (error: unknown, componentStack: string, eventId: string) => void;
  fallback?: React.ReactElement;
}

const ErrorBoundary = ({
  children,
  showDialog = false,
  onError,
  fallback,
}: ErrorBoundaryProps) => {
  const { logger } = useLogger({ componentName: "ErrorBoundary" });

  return (
    <Sentry.ErrorBoundary
      showDialog={showDialog}
      onError={
        onError ??
        ((error) => {
          logger.error("ErrorBoundary error", error as Error);
        })
      }
      fallback={fallback ?? <ErrorFallback />}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
};

export default ErrorBoundary;
